export function buildCityJsonLd(city) {
  const shortName = city.short_name;
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        name: city.title,
        description: city.meta_description,
        about: [
          `${shortName}找对象`,
          `${shortName}脱单`,
          `${shortName}婚恋交友`,
          `${shortName}婚恋咨询`,
          `${shortName}婚姻修复`,
          `${shortName}严肃婚恋`,
        ],
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: `${shortName}怎么找对象、脱单？`,
            acceptedAnswer: {
              "@type": "Answer",
              text: `注册AI婚恋平台并完善${shortName}同城资料，完成AI测评后即可获得异性智能匹配推荐，支持${shortName}同城相亲找对象与脱单，并可预约专业咨询师免费陪伴。`,
            },
          },
          {
            "@type": "Question",
            name: `${shortName}有婚恋咨询、婚姻修复服务吗？`,
            acceptedAnswer: {
              "@type": "Answer",
              text: `平台配备专业婚恋咨询师，提供${shortName}同城婚恋咨询、婚姻咨询、婚姻修复、婚前辅导与恋爱指导，从找对象、交往到结婚全程陪伴。`,
            },
          },
          {
            "@type": "Question",
            name: `${shortName}婚恋平台有什么不一样？`,
            acceptedAnswer: {
              "@type": "Answer",
              text: "区别于仅做介绍的传统相亲模式，咨询师提供前期免费长期陪伴，结合AI智能匹配，帮助建立以结婚为目的的健康关系。",
            },
          },
        ],
      },
    ],
  };
}

export function citySeoFromApi(city) {
  return {
    title: city.title,
    metaDescription: city.meta_description,
    ogDescription: `${city.short_name}找对象、脱单、婚恋咨询与婚姻修复，AI智能匹配 + 咨询师免费陪伴。`,
    keywords: city.keywords,
    path: `/city/${city.slug}`,
    jsonLd: buildCityJsonLd(city),
  };
}
